export default __webpack_public_path__ + "static/media/12.553b5073.jpg";